var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"color-border-btn",attrs:{"ripple":false,"depressed":"","small":_vm.small,"x-small":_vm.xSmall,"outlined":"","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }